import React from 'react'
import styled from 'styled-components'
import { WiStars } from "react-icons/wi";
import { useNavigate } from 'react-router-dom';
export const Hero = () => {
  const navigate = useNavigate();
  return (
    <Section>
        <Sub>
        Trust AI With Your Business
        </Sub>
<HLine>
  <WiStars style={{color:'#184A2C', fontSize:'1em'}}/>
Let Your Business Speak <br/>  <span style={{color:'#820000'}}>AI Voice Agents <br/> for a Smarter Future</span>
</HLine>
<Sub>
With our advanced AI technology, we help businesses and hospitals<br/> prevent staff burnout, enhance patient experience, cut costs, <br/>and unlock endless possibilities. The future is arrangemessage.
</Sub>
<ButtonContainer>
{/* <But onClick={()=>navigate("/ai-demo")}>
    Get Started
</But> */}
{/* <But>
    How It Works?
</But> */}
</ButtonContainer>
        </Section>
  )
}

const Section = styled.section`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
margin-top: 5%;
gap: 20px;
`
const HLine = styled.h1`
font-family: 'Clash Grotesk', sans-serif;
// font-style: normal;
font-weight: 900;
        
color:#184A2C;
font-size: 5em;

text-align: center;
margin:0;
`
const Sub = styled.h2`
font-family: raritas, sans-serif;
font-style: normal;
color:#808080;
font-size: 18px;
font-weight: 500;
text-align: center;

margin:0;
`
const But = styled.button`
border-radius:24px;
background-color:transparent;
border: 2px solid #184A2C;
font-family: raritas, sans-serif;
font-style: normal;
color:#184A2C;
font-size: 18px;
font-weight: 500;
padding: 10px 20px;
`
const ButtonContainer = styled.div`

display:flex;
justify-content:space-around;
gap:10px;

`